// src/components/Strategies/Strategies.jsx
import React from "react";
import "./Strategies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlassChart,
  faMessage,
  faGift,
  faPenNib,
  faRobot,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";

const strategyItems = [
  {
    icon: faMagnifyingGlassChart,
    title: "Audit & gap check",
    description:
      "We review your current website, ads, SEO, and tracking to spot leaks, missed opportunities, and quick wins worth fixing first.",
  },
  {
    icon: faMessage,
    title: "Positioning & offer clarity",
    description:
      "We refine your message so visitors instantly understand what you do, why you're different, and what step to take next.",
  },
  {
    icon: faGift,
    title: "Funnel-first planning",
    description:
      "We map the journey from click → landing page → inquiry/sale so every channel supports one clear conversion goal.",
  },
  {
    icon: faPenNib,
    title: "Content that converts",
    description:
      "We create content themes that build trust: proof, benefits, FAQs, case studies, and buyer-intent pages that rank and sell.",
  },
  {
    icon: faRobot,
    title: "Automation & follow-ups",
    description:
      "We set up forms, CRM/email sequences, and reminders so leads don't go cold—and your team follows a repeatable process.",
  },
  {
    icon: faGlobe,
    title: "Measurement & iteration",
    description:
      "We track the right events, review performance weekly, and ship improvements so results compound month after month.",
  },
];

const Strategies = () => {
  return (
    <section className="sg3" aria-label="Our strategies">
      <div className="sg3-wrap">
        <header className="sg3-head">
          <p className="sg3-kicker">Our strategies</p>
          <h2>A clear system to grow—without random experiments.</h2>
          <p className="sg3-sub">
            We focus on clarity, conversion, and consistency. Each step supports the
            next, so your marketing becomes predictable.
          </p>
        </header>

        <div className="sg3-grid" role="list">
          {strategyItems.map((item) => (
            <article className="sg3-card" role="listitem" key={item.title}>
              <div className="sg3-icon" aria-hidden="true">
                <FontAwesomeIcon icon={item.icon} />
              </div>

              <div className="sg3-body">
                <h3 className="sg3-title">{item.title}</h3>
                <p className="sg3-desc">{item.description}</p>
              </div>

              <span className="sg3-arrow" aria-hidden="true">
                →
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Strategies;
